<template>
  <div class="sc--status" :style="{color: colors.messageStatus.bg}">
    <div class="sc--status-wrapper" v-if="message.delivery && !message.read">
      <p class="read uncheck" :style="{borderColor: colors.messageStatus.bg}" :title="$t('Unread')"></p>
    </div>
    <div class="sc--status-wrapper" v-if="message.delivery && message.read">
      <p class="read check" :style="{backgroundColor: colors.messageStatus.bg}" :title="$t('Read')"></p>
    </div>
    <div class="sc--status-wrapper" v-if="!message.delivery">
      <p class="delivery uncheck" :style="{borderColor: colors.messageStatus.bg}" :title="$t('Undelivered')"></p>
    </div>
    <div class="sc--status-wrapper" v-if="message.delivery">
      <p class="delivery check" :style="{backgroundColor: colors.messageStatus.bg}" :title="$t('Delivered')"></p>
    </div>
  </div>
</template>
<script>
export default {
  name: 'MessageStatus',
  inject: {
    colors: {
      type: Object
    }
  },
  props: {
    message: {
      type: Object,
      required: true
    }
  }
}
</script>

<style lang='scss' scoped>
.sc--status {
  margin-top: .1rem;
  font-size: 0.75rem;
}
.delivery {
  border-radius: 50%;
  float: right;
  margin-right: -4px;
}
.read {
  border-radius: 50%;
  float: right;
}
.check {
  padding: 1.5px 4px 3.5px 4px;
  border: 1px solid;
  &:after {
    content: '';
    display: block;
    width: 3px;
    height: 6px;
    border: solid white;
    border-width: 0 2px 2px 0;
    transform: rotate(45deg);
  }
}
.uncheck {
  padding: 1.5px 4px 3.5px 4px;
  border: 1px solid;
  &:after {
    content: '';
    display: block;
    width: 3px;
    height: 6px;
    border: solid;
    border-width: 0 2px 2px 0;
    transform: rotate(45deg);
  }
}
</style>
